import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide} from 'swiper/react';
import { SquareArrowOutUpRight } from 'lucide-react';
import { motion } from 'framer-motion';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/effect-cards';

// import required modules
import { EffectCards,Pagination,Navigation} from 'swiper/modules';
import { useMediaQuery } from 'react-responsive';

import projectsData from '../assets/data/projects.json';

const Projects = () => {

  const [projects, setProjects] = useState([]);

  useEffect(() => {
    setProjects(projectsData);
  }, []);
  const isSmallScreen = useMediaQuery({ query: '(max-width: 500px)' });

  return (
    <section className="projects-section" id="projects">
      <h1 className='title'>&lt;Projects/&gt;</h1>
      <div className='main-container'>
        <motion.div
          className='flex'
          initial={{ opacity: 0 }}
          whileInView={{  opacity: 1 }}
          transition={{ ease: "linear", duration: 1.2}}
          exit={{  opacity: 0 }}
        >
          <Swiper
            effect={'cards'}
            grabCursor={true}
            pagination={{
              clickable: true,
            }}
            modules={isSmallScreen ? [Pagination] : [Pagination, Navigation, EffectCards]} // Load necessary modules based on screen size
            className="mySwiper"
            spaceBetween={20}
          >
            {projects.map((project) => (
              <SwiperSlide key={project.title} className='glass-box'>
                <div className="slide-content">
                  <img src={project.image} alt={project.title} className="slide-image" loading="lazy"/>
                  <h2>{project.title} <small>{project.subtitle}</small></h2>
                  <p><strong>Main technologies:</strong> </p>
                  <div className='tech'>
                    {project.technologies.map((tech, index) => (
                      <div key={index} className='badge'>{tech}</div>
                    ))}
                  </div>
                  <p className='description'>
                    {project.description}
                  </p>
                  <p>
                    <small>{project.goal}</small>
                  </p>

                  <a aria-label="Visit website" className="btn btn-icon" href={project.url} target="_blank" rel="noopener noreferrer">
                    <SquareArrowOutUpRight />
                  </a>

                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </motion.div>
      </div>
    </section>
  );
};

export default Projects;